import ProductMixedStocksLightboxStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import PostcodeStore from '../../_flux/stores/postcode_store';
import ActiveProductBatchStocksStore from '../../_flux/stores/product_batch_stocks/active_product_batch_stocks_store';
import { postcodeInvalidAction } from '../../_flux/actions/postcode_actions';
import { unsetErrorMessageAction } from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import onCartMixedStocksComputeRequest from '../../_views/product_mixed_stocks/on_cart_mixed_stocks_compute_request';
import { setPostcodeV2 } from '../../_flux/helper/requests/set_postcode_v2';
import { validatePostcode } from '../../validator/PostcodeAutocompleteValidator';

export default function onPostcodeSubmit() {
    return () => {
        unsetErrorMessageAction();
        const { quantity } = ProductMixedStocksLightboxStore.getState();
        const { appliedPostcode, postcodeSuggestion, touched } = PostcodeStore.getState();
        const { activeProductBatchStocks } = ActiveProductBatchStocksStore.getState();
        if (validatePostcode(TYROOLA.globals.store, appliedPostcode, postcodeSuggestion, touched)) {
            onCartMixedStocksComputeRequest(appliedPostcode, activeProductBatchStocks.id.value, quantity, true);
            setPostcodeV2(appliedPostcode, true);
        } else {
            postcodeInvalidAction();
        }
    };
}
